<template>
  <button v-if="flag" type="button" class="vc-label w-max underline" @click="() => (flag = false)">
    + {{ props.formElement.properties.previewText }}
  </button>
  <FormText
    v-else
    :form-element="props.formElement"
    :error-message="props.errorMessage"
    @update:error-message="(error: ElementValidationResult) => emit('update:error-message', error)"
  />
</template>

<script lang="ts" setup>
import { ref } from "vue";
import FormText from "./form-text.vue";
import type { ElementValidationResult } from "../forms-sdk";
import type { ExpandableOptionalTextElement } from "../types";

interface IProps {
  formElement: ExpandableOptionalTextElement;
  errorMessage?: ElementValidationResult;
}

interface IEmits {
  (event: "update:error-message", error: ElementValidationResult): void;
}
const emit = defineEmits<IEmits>();

const props = defineProps<IProps>();
const flag = ref<boolean>(true);
</script>
